var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZpay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 1001,
    viewBox: "0 0 1001 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500.105,
    cy: 500.849,
    r: 500,
    fill: "#1111FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.135 237.418V315.624C312.135 320.042 315.717 323.624 320.135 323.624H517.297L208.109 632.812H351.994L661.182 323.624L661.109 323.42C671.382 313.476 677.768 299.542 677.768 284.115C677.768 255.373 655.598 231.809 627.426 229.589L627.365 229.418H623.07H320.135C315.717 229.418 312.135 233 312.135 237.418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.259 764.281V686.076C695.259 681.657 691.677 678.076 687.259 678.076H490.097L799.285 368.887H655.401L346.212 678.076L346.286 678.279C336.013 688.223 329.627 702.158 329.627 717.584C329.627 746.326 351.796 769.891 379.969 772.11L380.03 772.281H384.324H687.259C691.677 772.281 695.259 768.7 695.259 764.281Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZpay);
export default __webpack_public_path__ + "static/media/zpay.16590618243859aeaf9d467ae51525cf.svg";
export { ForwardRef as ReactComponent };